import { LitElement, PropertyDeclarations, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';
import { classMap } from 'lit/directives/class-map.js';
import { AtlContentHeadingGridProps, AtlGridTagNames } from './grid.props';
import { ifDefined } from 'lit/directives/if-defined.js';

@customElement(AtlGridTagNames.ContentHeadingGrid)
export class AtlContentHeadingGrid
   extends LitElement
   implements AtlContentHeadingGridProps
{
   declare horizontalSpacing?: boolean;
   declare rightBlockFullWithOnMobile?: boolean;

   static properties: PropertyDeclarations = {
      horizontalSpacing: { attribute: 'horizontal-spacing', type: Boolean },
      rightBlockFullWithOnMobile: {
         attribute: 'right-block-full-width-on-mobile',
         type: Boolean,
      },
   };

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
         ::slotted([slot='rightBlock']) {
            display: flex;
            align-self: flex-end !important;
         }
      `,
   ];

   render() {
      return html`
         <div
            class=${classMap({
               row: true,
               'grid-one-col': true,
               'px-0': this.horizontalSpacing === true,
            })}
         >
            <div class="col-md-8">
               <slot name="leftBlock"></slot>
            </div>
            <div
               class=${classMap({
                  'col-md-4': true,
                  'd-flex': true,
                  'justify-content-end': true,
               })}
               style=${ifDefined(
                  this.rightBlockFullWithOnMobile ? 'flex:auto' : undefined
               )}
            >
               <slot name="rightBlock"></slot>
            </div>
         </div>
      `;
   }
}
